import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_aq493fxbj4: FaireBrandEntity = {
  token: "b_aq493fxbj4",
  type: "brand",
  name: "Fancy Shmancy Baby",
  avatarUrl:
    "https://cdn.faire.com/fastly/43218d80ade15ce62a2e8011a3d6ee8a6dbd05bbe9d776e8a4828bd86cdbaaaa.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7145af596aae80c89cab527c9f2f6b673eec2229c00ad83efc1ab546f313310e.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/43218d80ade15ce62a2e8011a3d6ee8a6dbd05bbe9d776e8a4828bd86cdbaaaa.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7145af596aae80c89cab527c9f2f6b673eec2229c00ad83efc1ab546f313310e.webp",
  location: "Katonah, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.5,
  reviewCount: 31,
  isInsider: true,
  description:
    "Fancy Shmancy is a fun, whimsical brand that will have your child uniquely styled for all seasons and holidays. If you're a fan of ruffles, boys, glitz and glam, our brand will catch your eye! With our fun holiday sets, party dresses, dress up costumes, loungewear & swimsuits, we aspire to stand out!\n\nThe brand started with hand made, home sewn pieces & quickly evolved to keep up with demand. This will be our first year offering wholesale to stores across the country since we widened our inventory count & we can't wait to have everyone in on the fun!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:18.894Z",
    importedBy: "entity-db-cli",
  },
};
